import React from 'react';
import { Flex, ScrollView, StackScreen } from '@banhala/ui-kit';
import { AnalyticsScreen } from 'shared/src/context';
import { bridge, isIOS } from 'shared/src/utils';
import { Image } from 'react-native';
import { LaboratorySwitch } from './components/LaboratorySwitch';
import { useLogViewLaboratory } from './hooks/useLogViewLaboratory';
import { SearchIcon, CartIcon } from 'shared/src/component';
import {
  useHandleBackPressed,
  useLaboratorySetting,
  useReportTTFD,
} from 'shared/src/hooks';

const Laboratory = () => {
  const { showBackButton, onPressBack } = useHandleBackPressed();

  const { isOn: isLikeFolderOn, setIsOn: setIsLikeFolderOn } =
    useLaboratorySetting('IS_LIKE_FOLDER');
  const { isOn: isLGifImageOn, setIsOn: setIsLGifImageOn } =
    useLaboratorySetting('IS_GIF_IMAGE');
  const { isOn: isTouchVibrationOn, setIsOn: setIsTouchVibrationOn } =
    useLaboratorySetting('IS_TOUCH_VIBRATION');
  const { isOn: isScreenShotShareOn, setIsOn: setIsScreenShotShareOn } =
    useLaboratorySetting('IS_SELECT_GOODS_SCREEN_SHOT_SHARE');

  useLogViewLaboratory({
    IS_LIKE_FOLDER: isLikeFolderOn,
    IS_GIF_IMAGE: isLGifImageOn,
    IS_TOUCH_VIBRATION: isTouchVibrationOn,
    IS_AFTER_SCREEN_CAPTURE_SHARE: isScreenShotShareOn,
  });

  useReportTTFD();

  return (
    <AnalyticsScreen screen="LABORATORY">
      <StackScreen
        title="실험실"
        hideBackButton={!showBackButton}
        onPressBack={onPressBack}
        rightIcons={[
          <SearchIcon />,
          <CartIcon
            onPressCart={() => {
              bridge.logAnalyticsEvent({
                channel: ['firebase', 'facebook', 'amplitude', 'ablylog'],
                name: 'CLICK_CART',
                analytics: {
                  SCREEN: 'LABORATORY',
                  LANDING_FROM: 'CARTICON',
                },
              });
            }}
          />,
        ]}
      >
        <ScrollView>
          <Flex padding={{ vertical: 24 }} alignItems="center">
            <Image
              source={require('./images/img_lab.png')}
              style={{ height: 104 }}
              resizeMode="contain"
            />
          </Flex>

          <LaboratorySwitch
            laboratoryKey="IS_LIKE_FOLDER"
            isOn={isLikeFolderOn ?? false}
            onChange={setIsLikeFolderOn}
          />
          <LaboratorySwitch
            laboratoryKey="IS_GIF_IMAGE"
            isOn={isLGifImageOn ?? false}
            onChange={setIsLGifImageOn}
          />
          {isIOS && (
            <LaboratorySwitch
              laboratoryKey="IS_TOUCH_VIBRATION"
              isOn={isTouchVibrationOn ?? false}
              onChange={setIsTouchVibrationOn}
            />
          )}
          <LaboratorySwitch
            laboratoryKey="IS_SELECT_GOODS_SCREEN_SHOT_SHARE"
            isOn={isScreenShotShareOn ?? false}
            onChange={setIsScreenShotShareOn}
          />
        </ScrollView>
      </StackScreen>
    </AnalyticsScreen>
  );
};
export default Laboratory;
